<div>
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        Export Request Details
      </ng-template>
      <ng-template matTabContent>
        <app-export *ngIf="display">
        </app-export>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        Bulk Update Metadata Details
      </ng-template>
      <ng-template matTabContent>
        <app-bulk-update-status *ngIf="display">
        </app-bulk-update-status>
      </ng-template>
    </mat-tab>        
  </mat-tab-group>
</div>